import { CodedError } from '../../CodedError';
import { errorCodes } from '../../constants/errorCodes';

export class YardiInvalidFieldError extends CodedError {
  static get errorName() {
    return errorCodes.yardiInvalidFieldError.code;
  }

  constructor(message: string = errorCodes.yardiInvalidFieldError.message) {
    super(message);
    this.code = errorCodes.yardiInvalidFieldError.code;
    this.message = `${message} ${errorCodes.yardiInvalidFieldError.code}`;
    this.name = errorCodes.yardiInvalidFieldError.name;
  }
}
